import { Box, Grid } from "@mui/material";
import InfoBar from "components/common/InfoBar";
import { tokens } from "styles/Tokens";
import { getUIFormatDate } from "utils/DateHelper";
import Chip from "../../common/Chip";
import Typography from "../../common/Typography";

interface Props {
  metricDetails?: any;
  metricsBar?: boolean;
  sx?: object;
}
function MetricsContent(props: Props) {
  const { metricDetails, metricsBar = true, sx } = props;
  const { metricsName, metricScore, chipDetails, timeFrameName, dateAsOf, metricValue2, metricScoreDetails } =
    metricDetails;
  const stringData = getUIFormatDate(dateAsOf) === "Invalid date";
  if (metricsBar)
    return (
      <Grid
        sx={{ height: "73px", marginTop: "16px", marginBottom: "16px", ...sx }}
        display="flex"
        flexDirection="column"
      >
        <Grid item xs={12} display="flex" justifyContent="space-between" flexWrap="wrap">
          <Typography variant="body1" showBold color={tokens.Text.General.PrimaryHeadline}>
            {metricsName}
          </Typography>
          {metricScore && (
            <Typography variant="h5" showBold color={tokens.Text.General.PrimaryHeadline}>
              {metricScore}
            </Typography>
          )}

          {metricScoreDetails && (
            <Box>
              <Typography
                variant="h5"
                showBold
                color={metricScoreDetails?.color}
                component={"span"}
                sx={{ marginRight: "4px" }}
              >
                {metricScoreDetails?.label}
              </Typography>
              <Typography color={metricScoreDetails?.color} component={"span"}>
                {metricScoreDetails?.icon}
              </Typography>
            </Box>
          )}
        </Grid>
        <Grid item xs={12} display="flex" justifyContent="space-between" flexWrap="wrap">
          <Box>
            {" "}
            <>
              {" "}
              {dateAsOf && (
                <Typography variant="label" component={"div"}>
                  {stringData ? dateAsOf : `As of ${getUIFormatDate(dateAsOf)}`}
                </Typography>
              )}
              <Typography variant="label" component={"div"}>
                {timeFrameName}
              </Typography>
            </>
          </Box>
          {metricScore && chipDetails && (
            <Chip
              backgroundColor={chipDetails?.backGroundColor}
              color={chipDetails?.color}
              borderColor={chipDetails?.backGroundColor === "transparent" ? null : chipDetails?.color}
              label={chipDetails?.label}
              icon={chipDetails?.icon}
            />
          )}
          {metricValue2 && (
            <Typography variant="h5" showBold color={tokens.Text.General.PrimaryHeadline}>
              {metricValue2}
            </Typography>
          )}
        </Grid>
      </Grid>
    );
  else {
    return (
      <InfoBar
        sx={{ flexDirection: "row", justifyContent: "space-between" }}
        label={metricsName}
        value={metricScore}
        coloredScore={
          metricScoreDetails && (
            <Typography variant="body2" showBold color={metricScoreDetails?.color} sx={{ marginLeft: { xs: "auto" } }}>
              {metricScoreDetails?.label}
              {metricScoreDetails?.icon}
            </Typography>
          )
        }
        progressChip={
          metricScore && chipDetails
            ? {
                backgroundColor: chipDetails?.backGroundColor,
                color: chipDetails?.color,
                borderColor: chipDetails?.color,
                label: chipDetails?.label,
                icon: chipDetails?.icon
              }
            : {}
        }
      ></InfoBar>
    );
  }
}

export default MetricsContent;
